import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RenderContextComponent } from '../../../../../../../../../models/base/render-context-component';
import { GroupedByBrandShelfTalkerCardData } from '../../../../../../../../../models/shelf-talkers/grouped-by-brand-shelf-talker-card-data';
import type { VariantsGroupedByBrand } from '../../../../../../../models/variants-grouped-by-brand';
import type { ShelfTalkerCardSize } from '../../../../../../../../../models/enum/dto/shelf-talker-card-size';

@Component({
  selector: 'app-glass-house-shelf-talker-item',
  templateUrl: './glass-house-shelf-talker-item.component.html',
  styleUrls: ['./glass-house-shelf-talker-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GlassHouseShelfTalkerItemComponent extends RenderContextComponent {
  @Input() shelfTalkerCardData: GroupedByBrandShelfTalkerCardData;
  @Input() variantsGroupedByBrand: VariantsGroupedByBrand;
  @Input() cardSize: ShelfTalkerCardSize;
  @Input() viewingInLiveView: boolean;

  setupViews() {}
  setupBindings() {}
}
